export default "__VITE_ASSET__7f459ef5__"